(ns nl.mediquest.be-my-coach-frontend.core
  (:require
   [day8.re-frame.http-fx]
   [nl.mediquest.be-my-coach-frontend.config :as config]
   [nl.mediquest.be-my-coach-frontend.events :as events]
   [nl.mediquest.be-my-coach-frontend.views :as views]
   [re-frame.core :as re-frame]
   [reagent.dom.client :as dom-client]))

(defn dev-setup []
  (when config/debug?
    (println "dev mode")))

(defonce root
  (delay (dom-client/create-root (.getElementById js/document "app"))))

(defn ^:dev/after-load mount-root []
  (re-frame/clear-subscription-cache!)
  (dom-client/render @root [views/main-panel]))

(defn ^:export init []
  (re-frame/dispatch-sync [::events/initialize-db])
  (re-frame/dispatch [::events/get-filter-options])
  (re-frame/dispatch [::events/get-zorgverleners])
  (dev-setup)
  (mount-root))
